import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from 'app/services/app.service';
import { IAssistantUsageLogs, IAssistantUsageQuery, IAssistantUsageSummary } from './assistant-usage.models';

/**
 * Dashboard consumi assistente: dominio = X-Domain-Id (HeadersInterceptor), autorizzazione lato server (admin del dominio).
 */
@Injectable({
	providedIn: 'root'
})
export class AssistantUsageService{

	constructor(private http: HttpClient, private appService: AppService){}

	summary(query: IAssistantUsageQuery): Observable<IAssistantUsageSummary>{
		return this.http.get<IAssistantUsageSummary>(this.url('/assistant/usage/summary'), { params: this.params(query) });
	}

	logs(query: IAssistantUsageQuery): Observable<IAssistantUsageLogs>{
		return this.http.get<IAssistantUsageLogs>(this.url('/assistant/usage/logs'), { params: this.params(query) });
	}

	private params(query: IAssistantUsageQuery): HttpParams{
		let params = new HttpParams();
		for (const [key, value] of Object.entries(query)) {
			if (value !== null && value !== undefined && value !== '') params = params.set(key, String(value));
		}
		return params;
	}

	private url(path: string): string{
		return this.appService.getBaseServerAddress() + path;
	}
}
